import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { DownloadAs } from '../../../../../components/DownloadAs';
import { useReportCtx } from '../../../report-ctx';

/**
 * Dropdown for report download with predefined formats
 */
export const DownloadReportBtnRhf = () => {
  const { formState } = useFormContext<{ _format: string }>();
  const ctx = useReportCtx();
  const [loading, setLoading] = useState(false);

  return (
    <DownloadAs
      formats={ctx.formats || []}
      disabled={!formState.isValid || ctx.isLoading}
      loading={loading}
      onDownload={(format) => {
        setLoading(true);
        ctx.downloadReport(format).finally(() => {
          setLoading(false);
        });
      }}
    />
  );
};
